export default __webpack_public_path__ + "static/metabolic_swe-dc607e3f9b2d8503ae898abfaaae0f8c.png";